import * as React from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';

import cx from 'classnames';

import { Checkbox } from 'components/Checkbox';

import { useAppContext } from 'hooks/context/useAppContext';

import s from './consent.module.css';

const SMS_POLICY = 'https://glossgenius.com/sms-terms';
const PRIVACY_POLICY = 'https://glossgenius.com/privacy';

type TProps = {
  className?: string;
  register?: UseFormRegisterReturn;
};

export const SmsConsent = (props: TProps) => {
  const { className, register } = props;
  const { publicUser } = useAppContext();
  const { business_name } = publicUser;

  const disclaimer = (
    <p className={s.disclaimer}>
      By checking the box, you consent to receive automated text messages at
      this number from {business_name} that may include payment notifications,
      promotions for appointments, services and more. Consent is not a condition
      of purchase. Text STOP to stop and HELP for help. Msg frequency varies.
      Msg&data rates may apply. View{' '}
      <a
        href={SMS_POLICY}
        target="_blank"
        className={s.textButton}
        rel="noreferrer"
      >
        TERMS
      </a>{' '}
      &{' '}
      <a
        href={PRIVACY_POLICY}
        target="_blank"
        className={s.textButton}
        rel="noreferrer"
      >
        PRIVACY
      </a>
    </p>
  );

  return (
    <Checkbox
      id="sms-consent"
      name="sms-consent"
      className={cx(s.container, className)}
      label={`Get important updates from ${business_name}!`}
      register={register}
      content={disclaimer}
    />
  );
};
